module.exports = __webpack_public_path__ + "static/img/jigou-shenzhen-top.42fd3cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-shenzhen-top.png
// module id = hOW3
// module chunks = 2